import { useContext } from 'react';
import { AppContext } from '@/contexts/app-context';

export function useContactMeForm() {
    const { contactMeForm, setContactMeForm } = useContext(AppContext);

    return {
        contactMeForm,
        setContactMeForm,
    };
}
